import { useEffect, useState } from "react";
import api from "../lib/api";
import { Trash2, Check } from "lucide-react";
import { toast } from "sonner";

export default function AdminReservations() {
  const [items, setItems] = useState([]);
  const [editing, setEditing] = useState(null);
  const [durationDraft, setDurationDraft] = useState("");

  const load = () => api.get("/reservations").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);

  const remove = async (id) => { if (window.confirm("Delete this reservation?")) { await api.delete(`/reservations/${id}`); load(); } };

  const saveDuration = async (id) => {
    try {
      await api.patch(`/reservations/${id}`, { duration_min: Number(durationDraft) });
      toast.success("Duration updated");
      setEditing(null); setDurationDraft(""); load();
    } catch { toast.error("Failed to update"); }
  };

  return (
    <div data-testid="admin-reservations-page">
      <h1 className="font-serif-display text-4xl text-[#5979A9] mb-2">Reservations</h1>
      <p className="text-[#4A5568] text-sm mb-7">All reservation requests received through the website. Override the per-reservation duration if needed.</p>

      <div className="bg-white rounded-2xl border border-[#F0EAE6] overflow-x-auto">
        {items.length === 0 ? <p className="p-6 text-sm text-[#4A5568]">No reservations yet.</p> : (
          <table className="w-full text-sm">
            <thead className="bg-[#FAF4F1] text-[#5979A9]">
              <tr>
                <th className="text-left px-5 py-3">Date / Time</th>
                <th className="text-left px-5 py-3">Name</th>
                <th className="text-left px-5 py-3">Phone</th>
                <th className="text-left px-5 py-3">Guests</th>
                <th className="text-left px-5 py-3">Duration</th>
                <th className="text-left px-5 py-3">Notes</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {items.map((r) => (
                <tr key={r.id} className="border-t border-[#F0EAE6]" data-testid={`reservation-row-${r.id}`}>
                  <td className="px-5 py-3 font-medium text-[#5979A9]">{r.date} · {r.time}</td>
                  <td className="px-5 py-3">{r.full_name}</td>
                  <td className="px-5 py-3">{r.phone}</td>
                  <td className="px-5 py-3">{r.guests}</td>
                  <td className="px-5 py-3">
                    {editing === r.id ? (
                      <div className="flex items-center gap-2">
                        <input type="number" value={durationDraft} onChange={(e) => setDurationDraft(e.target.value)}
                               min="15" max="240" step="15" data-testid={`duration-input-${r.id}`}
                               className="w-20 bg-transparent border-b border-[#F0EAE6] focus:border-[#E05947] outline-none py-1"/>
                        <button onClick={() => saveDuration(r.id)} data-testid={`duration-save-${r.id}`} className="text-green-600"><Check size={14}/></button>
                      </div>
                    ) : (
                      <button onClick={() => { setEditing(r.id); setDurationDraft(r.duration_min || 90); }}
                              data-testid={`duration-edit-${r.id}`}
                              className="text-sm hover:text-[#E05947]">{r.duration_min || 90} min</button>
                    )}
                  </td>
                  <td className="px-5 py-3 text-[#4A5568] max-w-xs truncate">{r.notes || "—"}</td>
                  <td className="px-5 py-3 text-right"><button onClick={() => remove(r.id)} className="text-[#E05947]"><Trash2 size={14}/></button></td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
